import { ActiveCrossDockSelect, ActiveLocationSelect } from './components';
import { t } from '@/core/localization';
export const sidebarNavigationItems = [
    {
        groupName: t('crossdocking.label'),
        element: ActiveCrossDockSelect,
        menuItems: ['crossdockingReceipt', 'packing', 'shipping', 'crossdockingBlocked'],
    },
    {
        groupName: t('stock.label'),
        element: ActiveLocationSelect,
        menuItems: ['picking', 'stockReceipt', 'stocks', 'storage', 'stockBlocked'],
    },
    {
        groupName: t('settings.label'),
        menuItems: ['settings'],
    },
];
